export default __webpack_public_path__ + "static/media/twitter.d3389b38.png";